import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const ClinicPhoneSetting = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["clinic-phone"], queryFn: async () => (await api.get("/settings/clinic-phone")).data });
  const [phone, setPhone] = useState("");
  useEffect(() => { if (data?.phone) { setPhone(data.phone); } }, [data?.phone]);
  const save = useMutation({
    mutationFn: async () => (await api.put("/settings/clinic-phone", { phone })).data,
    onSuccess: (r) => {
      toast.success(`Clinic number set to ${r.phone} in every text`);
      setPhone(r.phone);
      ["clinic-phone", "automatic-texts", "sms-settings", "birthdays", "message-templates", "templates"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
    },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not save"),
  });
  const changed = data && phone.trim() !== data.phone;

  return (
    <div data-testid="clinic-phone-setting">
      <div className="text-sm font-semibold text-slate-700 mb-1">Clinic call-back number</div>
      <p className="text-xs text-slate-500 mb-2">Used in every text and the birthday email. Changing it updates all automatic texts, keyword replies, saved templates and birthday messages at once.</p>
      <div className="flex flex-wrap items-center gap-2">
        <Input data-testid="clinic-phone-input" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="713-828-1476" className="h-9 w-44" inputMode="tel" />
        <Button size="sm" disabled={!changed || save.isPending}
          onClick={() => window.confirm(`Change the clinic number from ${data.phone} to ${phone.trim()} in every text?`) && save.mutate()}
          data-testid="clinic-phone-save">Update everywhere</Button>
      </div>
    </div>
  );
};
